var exports = {
  "P": "ProfileCardLayout.module__previewLabel___TmJaaV",
  "K": "ProfileCardLayout.module__profileCard___TmJaaV",
};

module.exports = exports;
